import { createProspectList } from "../../api/database";

// A category made with "+ New category" and nothing in it yet is only a
// heading saved on the view config (ViewConfig.empty_groups) - there is no
// list behind it, so every "which list?" picker that reads the lists left it
// out. Genneva Smarrelli, CRM-2026-00099 (Monday 13234478065, 8 Oct 2026):
// "Vendor enquires chaselist" and "Listed" were added but could not be picked
// to transfer leads into. The pickers now offer them too, and picking one
// makes the heading's own list the same way clicking the heading does.

export const CATEGORY_PREFIX = "category:";

const same = (a, b) => (a || "").trim().toLowerCase() === (b || "").trim().toLowerCase();

// The saved headings that have no list in them at all yet.
export const emptyCategoryTitles = (lists, emptyGroups) => {
  const seen = [];
  (emptyGroups || []).forEach((raw) => {
    const title = (raw || "").trim();
    if (!title) return;
    if ((lists || []).some((l) => same(l.group_name, title))) return;
    if (seen.some((t) => same(t, title))) return;
    seen.push(title);
  });
  return seen.sort((a, b) => a.localeCompare(b));
};

export const categoryOptionValue = (title) => `${CATEGORY_PREFIX}${title}`;

export const isCategoryOption = (value) => String(value || "").startsWith(CATEGORY_PREFIX);

// Turn a picked option into a real list id: an empty category gets its own
// list of the same name inside it (exactly what clicking the heading does),
// anything else is already a list id.
export const resolveListChoice = async (view, value) => {
  if (!isCategoryOption(value)) return value || null;
  const title = String(value).slice(CATEGORY_PREFIX.length);
  const res = await createProspectList({ view, name: title, group_name: title });
  return res?.data?.id || null;
};
